import { LinkOutlined } from '@ant-design/icons';
import { Avatar, Tag } from 'antd';
import { FC } from 'react';

import classes from './MessagePreview.module.scss';
import { findPushTypeOption } from './constants';

interface MessagePreviewProps {
  title?: string;
  body?: string;
  type?: string;
  categoryLabel?: string;
  categoryIconUrl?: string;
  actionType?: string | null;
  actionValue?: string | null;
  channelName?: string;
}

const MessagePreview: FC<MessagePreviewProps> = ({
  title,
  body,
  type,
  categoryLabel,
  categoryIconUrl,
  actionType,
  actionValue,
  channelName,
}) => {
  const hasContent = !!(title || body);
  const typeOption = type ? findPushTypeOption(type) : null;

  return (
    <div className={classes.previewContainer}>
      <div className={classes.previewLabel}>미리보기</div>
      <div className={classes.phoneFrame}>
        <div className={classes.statusBar}>
          <span>9:41</span>
          <span>{channelName || '채널'}</span>
        </div>

        {hasContent ? (
          <>
            <div className={classes.notificationCard}>
              <div className={classes.appIconLarge}>
                {categoryIconUrl ? <Avatar size={32} src={categoryIconUrl} shape='square' /> : 'G'}
              </div>
              <div className={classes.notificationContent}>
                <div className={classes.notificationTopRow}>
                  <span className={classes.notificationTitle}>
                    {title || <span className={classes.placeholder}>제목을 입력하세요</span>}
                  </span>
                  <span className={classes.timestamp}>지금</span>
                </div>

                {body && <div className={classes.notificationBody}>{body}</div>}
              </div>
            </div>

            {(typeOption || categoryLabel) && (
              <div className={classes.metaRow}>
                {typeOption && <Tag color={typeOption.color}>{typeOption.label}</Tag>}
                {categoryLabel && (
                  <span className={classes.categoryBadge}>
                    {categoryIconUrl && <Avatar size={14} src={categoryIconUrl} />}
                    {categoryLabel}
                  </span>
                )}
              </div>
            )}
            {actionType === 'navigate' && (
              <div className={classes.actionBanner}>
                <span className={classes.actionLabel}>
                  <LinkOutlined />
                  페이지 이동
                </span>
                {actionValue ? (
                  <span className={classes.actionPath}>{actionValue}</span>
                ) : (
                  <span className={classes.actionPending}>경로 미입력</span>
                )}
              </div>
            )}
          </>
        ) : (
          <div className={classes.emptyState}>
            메시지를 작성하면
            <br />
            미리보기가 표시됩니다.
          </div>
        )}
      </div>
    </div>
  );
};

export default MessagePreview;
